import { projectService } from '../_services';

export const projects = {
    namespaced: true,
    state: {
        all: {},
        inview: {},
        saved: {}
    },
    actions: {
        getAll({ commit }) {
            commit('getAllRequest');

            projectService.getAll()
                .then(
                    projects => commit('getAllSuccess', projects),
                    error => commit('getAllFailure', error)
                );
        },

        getOne({ dispatch, commit }, { projectid }) {
            commit('getOneRequest');
            
            console.log( projectid )
            
            projectService.getOne( projectid )
                .then(
                    project => commit('getOneSuccess', project),
                    error => commit('getOneFailure', error)
                );
        },


        save({ dispatch, commit }, { id, data, access }) {
            commit('saveRequest');

            return projectService.save( id, data, access )
               .then(
                    project => {
                        commit('saveSuccess', project );
                        //resolve( product )
                        //router.push('/thankyou');
                        return project
                    },
                    error => {
                        commit('saveError', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },

    },
    mutations: {
        getAllRequest(state) {
            state.all = { loading: true };
        },
        getAllSuccess(state, projects) {
            state.all = { items: projects };
        },
        getAllFailure(state, error) {
            state.all = { error };
        },


        getOneRequest(state) {
            state.inview = { loading: true };
        },
        getOneSuccess(state, project) {
            state.inview = { item: project };
        },
        getOneFailure(state, error) {
            state.inview = { error };
        },


        
        
        saveRequest(state){
            state.saved = { loading: true };
        },
        saveSuccess(state, project){
            state.saved = project ;
        },
        saveError(state, error ){
            state.saved = { error };
        },
        
        
    }
}